import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=1a3703c5&scoped=true&"
import script from "./Pedido.vue?vue&type=script&lang=js&"
export * from "./Pedido.vue?vue&type=script&lang=js&"
import style0 from "./Pedido.vue?vue&type=style&index=0&id=1a3703c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3703c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSlideGroup,VSlideItem})
